<div class="onboard-page">

  <!-- Stepper -->
  <div *ngIf="!store.isComplete()" class="d-flex justify-content-between mt-3" style="margin-bottom: 44px">
    <div style="width:5%"></div>
    <div class="d-flex justify-content-between onboard-stepper" style="width:90%">
      <!-- Account Setup — always shown as completed; user cannot go back -->
      <div class="onboard-step-done">
        <i class="icon ion-ios-checkmark-empty"></i>
        <div class="step-label">Account Setup</div>
      </div>
      <div class="onboard-step-connector connector-done"></div>
      <ng-container *ngFor="let label of store.STEP_LABELS(); let i = index">
        <div class="onboard-step"
             *ngIf="i >= store.currentStep()"
             [ngClass]="{'is-active': i === store.currentStep()}">
          <div class="step-label">{{ label }}</div>
        </div>
        <div class="onboard-step-done"
             *ngIf="i < store.currentStep()">
          <i class="icon ion-ios-checkmark-empty"></i>
          <div class="step-label">{{ label }}</div>
        </div>
        <div class="onboard-step-connector"
             *ngIf="i < store.STEP_LABELS().length - 1"
             [ngClass]="{'is-active-bar': i === store.currentStep(), 'connector-done': i < store.currentStep()}">
        </div>
      </ng-container>
    </div>
    <div style="width:5%"></div>
  </div>

  <!-- Hero banner -->
  <div *ngIf="!store.isComplete()" class="onboard-hero">
    <div class="onboard-hero-content">
      <div class="onboard-hero-title">Hey 👋 {{userName}}, Welcome to TaxPlanIQ</div>
      <div class="onboard-hero-subtitle">
        Maximize your experience with us! Follow these simple steps to dive into all the features and unlock the full potential of your new tools.
      </div>
    </div>
    <div class="onboard-hero-illustration">
      <app-signup-banner></app-signup-banner>
    </div>
  </div>

  <!-- Step router -->
  <div [ngSwitch]="store.currentLabel()">
<app-meeting-step   *ngSwitchCase="'Book your Meeting'"></app-meeting-step>
    <app-invite-step    *ngSwitchCase="'Invite Additional User'"></app-invite-step>
    <app-success-screen *ngSwitchDefault></app-success-screen>
  </div>

</div>
